import React from "react";
import { Modal } from "react-bootstrap";
import { FacebookIcon, InstapaperIcon, TelegramIcon, TwitterIcon, WhatsappIcon } from "react-share";
import {
  FacebookShareButton,
  InstapaperShareButton,
  TelegramShareButton,
  TwitterShareButton,
  WhatsappShareButton,
} from "react-share";

const ShareDialog = ({ visible, onHide, url }) => {
  return (
    <Modal centered show={visible} onHide={onHide}>
      <Modal.Header closeButton />

      <Modal.Body>
        <div className="d-flex justify-content-around align-items-center">
          <FacebookShareButton url={url} quote={"title"}>
            <FacebookIcon size={32} round />
          </FacebookShareButton>

          <InstapaperShareButton url={url} quote={"title"}>
            <InstapaperIcon size={32} round />
          </InstapaperShareButton>

          <TelegramShareButton url={url} quote={"title"}>
            <TelegramIcon size={32} round />
          </TelegramShareButton>

          <TwitterShareButton url={url} quote={"title"}>
            <TwitterIcon size={32} round />
          </TwitterShareButton>

          <WhatsappShareButton url={url} quote={"title"}>
            <WhatsappIcon size={32} round />
          </WhatsappShareButton>
        </div>

        <div className="p-3 bg-light rounded w-100 mt-4 text-center" style={{ fontSize: 14 }}>
          {url}
        </div>
      </Modal.Body>
    </Modal>
  );
};

export default ShareDialog;
